//设备离线
import {t} from "i18next";
import React from 'react'
export const offlinePara = [
    {
        titlekey: 'All.Parameter.psName',
        dataIndex: 'psName',
        key: 'psName',
        width: 198,
        fixed: 'left',
    },
    {
        titlekey: 'All.Parameter.deviceName',
        dataIndex: 'deviceName',
        key: 'deviceName',
        render: (text) => (text ? <span className='Italic'>{text}</span> : '-'),
        width: 98,
        fixed: 'left',
    },
    {
        titlekey: 'All.Parameter.addressCode',
        dataIndex: 'deviceAddress',
        key: 'deviceAddress',
        align: 'center',
        width: 88,
    },
    {
        titlekey: 'All.Parameter.content',
        dataIndex: 'failureName',
        key: 'failureName',
        width: 68,
        render: (_, record) => {
            return (
                t('All.Operation.Filter.AlarmType.offline')
            )
        }
    },
    {
        titlekey: 'All.Parameter.beginTime',
        dataIndex: 'offlineTime',
        key: 'offlineTime',
        width: 138,
        render: null
    }
]

//设备故障
export const failurePara = [
    {
        titlekey: 'All.Parameter.psName',
        dataIndex: 'psName',
        key: 'psName',
        width: 198,
        fixed: 'left',
    },
    {
        titlekey: 'All.Parameter.deviceName',
        dataIndex: 'deviceName',
        key: 'deviceName',
        width: 98,
        fixed: 'left',
        render: (text) => (text ? <span className='Italic'>{text}</span> : '-'),
    },
    {
        titlekey: 'All.Parameter.addressCode',
        dataIndex: 'deviceAddress',
        key: 'deviceAddress',
        align: 'center',
        width: 88,
    },
    {
        titlekey: 'All.Parameter.deviceIP',
        dataIndex: 'deviceIp',
        key: 'deviceIp',
        align: 'center',
        width: 108,
        render: (_, record) => {
            return record.deviceIp || '-';
        }
    },
    {
        titlekey: 'All.Parameter.content',
        dataIndex: 'failureName',
        key: 'failureName',
        width: 278,
    },
    {
        titlekey: 'All.Parameter.beginTime',
        dataIndex: 'getdatetime',
        key: 'getdatetime',
        align: 'left',
        width: 138,
        render: null
    },
    {
        titlekey: 'All.Parameter.operation',
        dataIndex: 'opera',
        key: 'opera',
        width: 118,
        align: 'center',
        fixed: 'right',
        render: null,
        onCell: () => ({
            'data-operation': 'true'
        })
    }
]

//通讯异常
export const abnormalPara = [
    {
        titlekey: 'All.Parameter.psName',
        dataIndex: 'psName',
        key: 'psName',
        width: 198,
        fixed: 'left',
    },
    {
        titlekey: 'All.Parameter.content',
        dataIndex: 'failureName',
        key: 'failureName',
        width: 68,
        render: (_, record) => {
            return (
                t('All.Operation.Filter.AlarmType.commInterruption')
            )
        }
    },
    {
        titlekey: 'All.Parameter.beginTime',
        dataIndex: 'offlineTime',
        key: 'offlineTime',
        width: 138,
        render: null
    }
]

//阈值报警
export const thresholdPara = [
    {
        titlekey: 'All.Parameter.psName',
        dataIndex: 'psName',
        key: 'psName',
        width: 198,
        fixed: 'left',
    },
    {
        titlekey: 'All.Parameter.deviceName',
        dataIndex: 'deviceName',
        key: 'deviceName',
        render: (text) => (text ? <span className='Italic'>{text}</span> : '-'),
        width: 98,
        fixed: 'left',
    },

    {
        titlekey: 'All.Parameter.deviceParameter',
        dataIndex: 'threshold',
        key: 'threshold',
        width: 68,
    },
    {
        titlekey: 'All.Parameter.thresholdSetting',
        dataIndex: 'threshold',
        key: 'threshold',
        width: 138
    },
    {
        titlekey: 'All.Parameter.content',
        dataIndex: 'failureName',
        key: 'failureName',
        width: 68,
        render: (_, record) => {
            return (
                t('All.Operation.Filter.AlarmType.thresholdAlarm')
            )
        }
    },
    {
        titlekey: 'All.Parameter.beginTime',
        dataIndex: 'thresholdTime',
        key: 'thresholdTime',
        width: 138,
        render: null
    },
    {
        titlekey: 'All.Parameter.detail',
        width: 38,
        align: 'right',
        fixed: 'right',
        render: null,
        onCell: () => ({
            'data-operation': 'true'
        })
    }
]